import { isTempId } from "@common-reducers/DBServiceThunks";
import {
  setExtraDataOfTaskId
} from "@common-reducers/ExtraDataReducer";
import { taskActions } from "@common-reducers/TasksReducer";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { MessageSquareText } from "lucide-react";
import { getTaskExtradataLength } from "@common-reducers/TaskSelectors";
import { Button } from "@/components/ui/button";

export interface Props {
  taskId: string;
}

function ExtraDataButton({ taskId }: Props) {
  const dispatch = useAppDispatch()
  const taskExtradataLength = useAppSelector((state) => getTaskExtradataLength(state, taskId));

  function openExtraDataPanel() {
    updateURLParameter(taskId)
    dispatch(setExtraDataOfTaskId(taskId));
    dispatch(taskActions.setTaskViewSideDrawerOpenWith("ExtraDataPanel"));
  }
  function updateURLParameter(taskId: string) {
    let currentUrl = window.location.href;
    let newUrl;
    if (currentUrl.includes('taskId')) {
      newUrl = currentUrl.replace(/taskId=[^&]+/, `taskId=${taskId}`);
    } else{
    newUrl = currentUrl + `&taskId=${taskId}`;
    }
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
  return (

    <div className="relative inline-flex items-center justify-center">
      <Button 
        variant="ghost" 
        size="icon"
        className="h-10 w-10 hover:bg-transparent p-0"
        disabled={isTempId(taskId)}
        onClick={openExtraDataPanel} 
      >
        <MessageSquareText 
          className="h-[20px] w-[20px]" 
          color={isTempId(taskId) ? 'lightgrey' : "#809ba8"} 
          fill={isTempId(taskId) ? 'lightgrey' : "#809ba8"}
        />
      </Button>

      {taskExtradataLength > 0 && (
         <span className="absolute -top-[2px] right-0 bg-[#33A1FD] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full min-w-[17px] text-center flex items-center justify-center pointer-events-none">
          {taskExtradataLength}
        </span>
      )}
    </div>
  );
}

export default ExtraDataButton;
